export default __webpack_public_path__ + "static/media/delete.02c736a3.wav";